<template>
    <div class="text-center mx-auto mt-8">
        <heading :text="fields.radio_button_question" size="large"></heading>
        <div class="postcode-container">
            <radio-field
            v-for="(item, index) in fields.radio_button_options"
            :key="index"
            v-model="val"
            :option="item.label"
            :label="item.label"/>
        </div>
        <post-code-area :fields="fields" :option="val" ></post-code-area>
    </div>
</template>

<script>
import { Heading } from '@freddiesflowers/frontend-component-library';
import PostCodeArea from './PostCodeArea.vue';
import RadioField from '@/components/forms/fields/RadioField';

export default {
    name: 'postcode-checker',
    data: function() {
        return {
            val: null,
        };
    },
    props: {
        fields: {
            type: Object,
        },
    },
    components: {
        PostCodeArea,
        RadioField,
        Heading,
    },
};
</script>

<style lang="scss" scoped>
        .postcode-container {
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
            align-items: center;
            margin: 40px auto;
            max-width: 400px;
        }
        @media (max-width: 768px) {
        .postcode-container {
            justify-content: space-evenly;
            align-items: flex-start;
        }
    }
</style>
